import Pricing from './pricing';

export default function Memberships() {
  return (
    <div style={{width: '100%'}}>
        <Pricing />
    </div>
  );
}
